export default {"src":"/_next/static/media/FINANCIALS_DISABLED.07477d4b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};